"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreeState = /** @class */ (function () {
    function TreeState() {
        this.templates = [];
        this.id = new Date().getTime();
    }
    Object.defineProperty(TreeState.prototype, "activeElement", {
        get: function () {
            return this._activeElement;
        },
        set: function (element) {
            this._activeElement = element;
            this.editingLabel = element.label;
            this.activeElementEditing = false;
        },
        enumerable: true,
        configurable: true
    });
    return TreeState;
}());
exports.TreeState = TreeState;
;
//# sourceMappingURL=TreeState.js.map